import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/gxp-qa-training")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/regulatory-compliance-training", statusCode: 301 }); },
});
